import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'document',
  type: 'file--file',
  attributes: {
    data: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'data',
    },
    uri: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'name',
    },
  },
  relationships: {
    user: {
      type: 'user--user',
      required: false,
      isArray: false,
      name: 'uid',
    },
  },
};
export const FileService = createService(base, configuration, API_CONFIG.API);
export const FileModule = createModule(FileService, true);



// WEBPACK FOOTER //
// ./src/models/file.js